if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    // burger menu funcionality

	const burgerMenu = document.querySelector(".js-burger-menu");
	const closeMenu = document.querySelector(".burger-close-js");
	const openMenu = document.querySelectorAll(".js-menu-buger");

	//Open Menu
	openMenu.forEach( cta => {
		cta.addEventListener('click', function (e) {
			e.preventDefault();
			burgerMenu.classList.add("open");
			document.body.classList.add("no-scroll");
		});
	});

	//Close Menu
	closeMenu.addEventListener('click', (e) => {
		e.preventDefault();
		burgerMenu.classList.remove("open");
		document.body.classList.remove("no-scroll");
	});
    
   // slick default setting
	let defaulsettings = {loop: true,speed: 700,effect: 'fade',fadeEffect: {crossFade: true},navigation: { nextEl: '.swiper-prev', prevEl: '.swiper-next' },autoplay: {delay: 5000,disableOnInteraction: false}};

	// start slider default
    let allSwipper =[];

	document.querySelectorAll('.swiper-js').forEach((element,i) => {

		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;

		element.setAttribute(`data-swiper-${i}`,"");

		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);

        allSwipper[i] = swiper;

	});
    
    document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0;
		const slider = item.dataset.swipertarget ? document.querySelector(item.dataset.swipertarget) : item.closest('.swiper-js');
		item.addEventListener('click', () => {
			slider.swiper.slideTo(target);
			document.querySelectorAll('[data-swiper-goto]').forEach((itm) => itm.classList.remove('active'));
			item.classList.add('active');
            if (document.querySelectorAll('[data-swiper-txt]') != null) {
                document.querySelectorAll('[data-swiper-txt]').forEach((text, i) => {

                    let textdata = text.dataset.swiperTxt
                    text.classList.remove('active');

                    if(target == textdata){
                        text.classList.add('active');
                    }
                })
            }
		});
	});


    //custom swiper controller
    allSwipper.forEach((swiper) => {
        const customControl = swiper.passedParams.customcontrol;
        if (customControl) {
            const targetIds = customControl.substr(1).split(" ");
            const targetSwipers = allSwipper.filter((s) => targetIds.includes(s.el.id));
            if (targetSwipers.length > 0) {
                swiper.controller.control = targetSwipers;
            }
        }
    });

    ////accordion Funcionality
	let acordionitems = document.querySelectorAll(".accordion-js h2");
	acordionitems.forEach((item) => {
		item.addEventListener("click", (element) => {
            element.target.classList.toggle("active");
            element.target.nextElementSibling.classList.toggle("active");
		});
	});

    //For Menu Tabs
    document.querySelectorAll('.menu-tab-js').forEach((btn, i) => {
        btn.addEventListener('click', element => {
            element.preventDefault()
                document.querySelectorAll('.menu-tab-js').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');

                document.querySelectorAll('.menu-item-js').forEach(menu => {
                    menu.classList.remove('active');
                        if ( btn.dataset.tag === 'all' || btn.dataset.tag === menu.dataset.tag ) {
                            menu.classList.add('active');
                        }
                });
        });

        if (i === 0) btn.click();
    });

    const select_menu = document.querySelector('#select-menu');
    if (select_menu != null) {
        
        select_menu.addEventListener('change', _ => {
            document.querySelectorAll('.menu-item-js').forEach(menu => {
                menu.classList.remove('active');
                if ( select_menu.value === 'all' || select_menu.value === menu.dataset.tag ) {
                    menu.classList.add('active');
                }
            });
        });
    }

    //js animation parallax imagen
    const images = document.querySelectorAll('#home figure img:not(.no-parallax), #default figure img:not(.no-parallax),.parallax');
    new Ukiyo(images,{
        scale: 1.15,
        speed: 1.5,
        willChange: true
    });

    // validation intro
    const introContent = document.querySelector("#default .intro-content");
    if (introContent != null) {
        if (introContent.nextElementSibling.classList.contains("amenities-block")) {
            introContent.classList.add("has-amenities")
        }
        
    }

    // scroll animation
	if(document.querySelector(".scroll-down") != null){
		document.querySelector(".scroll-down").addEventListener('click', function(e){
            e.preventDefault();
			animateTo('intro-content');
		});
	}

    // LBX class overflow
	LBX._instances[0].beforeShow = () => {document.querySelector("body").classList.add("no-scroll")};
	LBX._instances[0].beforeClose = () => {document.querySelector("body").classList.remove("no-scroll")};

    // GALLERY-FLEX FULLSCRREN MODE
	if (typeof customLightbox !== 'undefined') {
		customLightbox.fullScreen = true;
		customLightbox.wideArrows = false;
        customLightbox.beforeShow = () => {document.querySelector("body").classList.add("no-scroll")};
        customLightbox.beforeClose = () => {document.querySelector("body").classList.remove("no-scroll")};
	}
    //Home resonsive title
    const herotext = document.querySelector(".scroll-down__text");
    if (herotext && window.innerWidth <= 900) {
        herotext.textContent = "swipe down";
    }

    //ADA
    let removeNavId = document.querySelector(".burger-menu .tertiary-navigation");

    if (removeNavId != null)  {
        removeNavId.removeAttribute("id");
        removeNavId.firstElementChild.removeAttribute("id");
    }
    let removeIdSocial = document.querySelector(".burger-menu .social-media .twitter svg path");
    if (removeIdSocial != null)  {
        removeIdSocial.removeAttribute("id");
    }
})();
